
import SEO from '@/components/SEO';
import { OG_IMAGES } from '@/constants/seoImages';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import PartnerLogosSection from '@/components/shared/PartnerLogosSection';
import PartnerTypesSection from '@/components/partners/PartnerTypesSection';
import IntegrationBenefitsSection from '@/components/partners/IntegrationBenefitsSection';
import PartnershipLevelsSection from '@/components/partners/PartnershipLevelsSection';

const Partners = () => {
  return (
    <>
      <SEO
        title="Partners - Join the SeniorThrive Ecosystem"
        description="Partner with SeniorThrive to bring safety, wellness, and coordination to the families you serve. Integration opportunities for healthcare providers, home care agencies, and technology companies."
        keywords="senior care partnerships, healthcare integration, home care technology, senior living partners, aging in place solutions, SeniorThrive partner"
        canonical="https://seniorthrive.com/partners"
        image={OG_IMAGES.partners}
      />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-cover bg-center bg-no-repeat overflow-hidden" style={{ backgroundImage: "url('/uploads/hero-partners-wc.jpg')" }}>
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="relative z-10 container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="bg-black/50 backdrop-blur-sm rounded-md p-8 md:p-10">
              <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight text-white">
                Help More Families Thrive at Home
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-white/90">
                Partner with SeniorThrive to bring safety, wellness, and coordination to the families you serve.
              </p>
              <p className="text-lg text-white/80 max-w-2xl mx-auto">
                Whether you are a healthcare provider, home care agency, or technology company, there is a place for you in this ecosystem.
              </p>
            </div>
          </div>
        </div>
      </section>

      <PartnerTypesSection />
      
      <IntegrationBenefitsSection />

      <PartnershipLevelsSection />

      {/* Current Partners */}
      <PartnerLogosSection
        title="Services Families Already Trust"
        description="SeniorThrive connects with everyday services to make daily life at home easier"
        className="py-16"
      />

      {/* CTA Section */}
      <section className="py-20 bg-[var(--gray-50)]">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6 text-foreground">Let's Build Something Together</h2>
            <p className="text-xl mb-8 text-muted-foreground">
              Talk with our team about integrations, partnerships, and how we can help more families thrive at home.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Button asChild size="lg">
                <Link to="/contact">Inquire About Partnership</Link>
              </Button>
              <Button asChild size="lg" variant="outline">
                <Link to="/affiliate-program">Explore Our Affiliate Program</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Partners;
